import * as React from "react";
import { Link } from "react-router-dom";
import { CaseRunClient, ClientResources, BrutusCaseRunModel, BrutusTestType, BrutusFeature } from "@app/api2/api";
import { buildUrl, AppRoutes } from "../../../../AppRoutes";
import { BPColumn } from "@common/BPReactTable";
import { getRunStatusAsString, toSci } from "@common/Utils";
import { BPDataTable3 } from "@app/components/React/Common/DataTable/BPDataTable3";

interface BrutusCaseRunsProps {
    labId: number;
    caseId: number;
    canCreateEvidence: boolean;
}

export class BrutusCaseRuns extends React.Component<BrutusCaseRunsProps> {
    client: CaseRunClient = new CaseRunClient();
    translationsContext: React.Context<ClientResources>;

    constructor(props, context) {
        super(props, context);
        
    }

    render() {
        const columns: BPColumn<BrutusCaseRunModel>[] = [
            {
                Header: "Id",
                accessor: 'id',
                disableSortBy: false,
                Cell: item => <Link to={buildUrl(AppRoutes.CaseRunDetails, {
                    caseId: this.props.caseId.toString(),
                    caseRunId: item.value.toString(),
                    labId: this.props.labId.toString()
                })}>{item.value}</Link>,
                width: "70px",
            },
            {
                Header: window.translation.common.runType,
                accessor: 'friendlyRunType',
                width: '80px',
                cellTitle: true,
            },
            {
                Header: window.translation.brutus.testType,
                accessor: 'brutusTestType',
                Cell: item => <>{BrutusTestType[item.value]}</>,
                width: '80px',
                cellTitle: true,
            },
            {
                Header: window.translation.parameter.names.brutusFeatureToUse,
                accessor: 'brutusFeatureToUseEnum',
                Cell: item => <>{item.value == BrutusFeature.None ? window.translation.brutus.featureNone : item.value == BrutusFeature.Mutations ? window.translation.brutus.featureMutations : window.translation.brutus.featureSilentAllele}</>,
                width: '90px',
                cellTitle: true
            },
            {
                Header: window.translation.common.population,
                accessor: 'populationName',
                disableSortBy: true,
                cellTitle: true,
                width: "150px",
            },
            {
                Header: window.translation.caseRunView.likelihoodRatioShort,
                accessor: 'likelihoodRatioStr',
                Cell: item => <>{toSci(item.value, 4)}</>,
                width: '100px',
            },
            {
                Header: window.translation.common.status,
                accessor: 'status',
                disableSortBy: true,
                width: "100px",
                Cell: item => <>{getRunStatusAsString(item.value)}</>,
            },
        ];

        return (
            <BPDataTable3
                singleLine
                fixed
                defaultSortField="id"
                defaultSortAsc={false}
                enableSearch={true}
                dataSource={async (p) => {
                    let pageData = await this.client.getBrutusRuns(this.props.labId, this.props.caseId, p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue);
                    return pageData;
                }}
                columns={columns}
            />
        );
    }
}

